import { PlanningCardFieldDescriptor } from '../planning-card-field';

/**
 * Card fields for the ServiceWorkOrder card, in display order. The header (number/customer/status) is
 * listed first as `fixed` — always shown, locked in the config panel. `schedule` and `kind` are synthetic
 * keys gating the computed schedule line and the kind badge.
 */
export const SERVICE_WORK_ORDER_CARD_FIELDS: PlanningCardFieldDescriptor[] = [
  { key: 'number', labelKey: 'Doc::Planning:CardField:Number', fixed: true },
  { key: 'customer', labelKey: 'Doc::Planning:CardField:Customer', fixed: true },
  { key: 'status', labelKey: 'Doc::Planning:CardField:Status', fixed: true },
  { key: 'article', labelKey: 'Doc::Article' },
  { key: 'articleCode', labelKey: 'Doc::Planning:CardField:ArticleCode' },
  { key: 'articleSerial', labelKey: 'Doc::StockDoc:ArticleSerial' },
  { key: 'responsible', labelKey: '::Responsible' },
  { key: 'schedule', labelKey: 'Doc::Planning:CardField:Schedule' },
  { key: 'kind', labelKey: 'Doc::Planning:CardField:Kind' },
];

/**
 * Typed view of a ServiceWorkOrder item's `PlanningItemDto.displayFields` payload. Mirrors the backend
 * `ServiceWorkOrderPlanningItemFieldsDto` record (Digiwall.GoliathDocuments.Planning) — keep the two in sync.
 * `displayFields` is transported as a loosely-typed object, so the card casts it to this interface.
 */
export interface ServiceWorkOrderPlanningItemFieldsDto {
  displayNumber?: string;
  customer?: string;
  article?: string;
  articleCode?: string;
  articleSerial?: string;
  /** ServiceWorkOrderKind enum key; resolved to a label/colour via the enumeration store. */
  kind?: string;
  forecastedDate?: string;
  plannedDate?: string;
  plannedDurationHours?: number;
  responsible?: string;

  // Filter fields — ids used by the client-side board filter predicate (not shown on the card).
  // Kept in sync with the backend record's filter-field block.
  customerId?: string;
  dayBookId?: string;
  articleId?: string;
  description?: string;
}
